import DesignSystem from './DesignSystem'

export default DesignSystem
